import { atom } from 'recoil'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import { IEquipmentModel } from '../Equipment/pages/EquipmentModels/equipmentModels.types'

export interface IDeviceMapFiltersState {
  models: Array<IEquipmentModel['id']>
  statuses: Array<IEquipment['state']>
  search: string
}

const deviceMapFiltersAtom = atom<IDeviceMapFiltersState>({
  key: 'equipmentFilterStatutes',
  default: {
    statuses: ['RUNNING', 'ERROR', 'STOPPED', 'DISCONNECTED'],
    models: [],
    search: '',
  },
})

export default deviceMapFiltersAtom
